module.exports = __webpack_public_path__ + "img/icon-sms.c6da224f.svg";